var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "progress-bar": true, "--animated": this.isAnimated } },
    [
      _c("div", {
        staticClass: "progress-bar__progress",
        style: { width: this.progressPercentage + "%" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }